import { render, staticRenderFns } from "./LanguageModal.vue?vue&type=template&id=8b765616&scoped=true"
import script from "./LanguageModal.vue?vue&type=script&lang=ts"
export * from "./LanguageModal.vue?vue&type=script&lang=ts"
import style0 from "./LanguageModal.vue?vue&type=style&index=0&id=8b765616&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b765616",
  null
  
)

export default component.exports